export default __webpack_public_path__ + "static/media/up-coming-event-1.2eb8e8b6.png";